import { PlatMapSettings, WXTilesV3Layer } from '@mono/types/src/platmap';

const defaultWXtilesV3State: WXTilesV3Layer = {
    type: 'wxtilesv3' as const,
    datasetId: 'gfs.global',
    variable: 'air.temperature.at-2m',
    styleId: 'base',
    styleOverrides: {
        isolineText: false,
        colorScheme: 'hspastel',
        colors: ['#AC6EA4FF', '#8E92BDFF', '#ACD4DEFF', '#E9DC8EFF', '#E7A97DFF', '#E59074FF', '#BE7E68FF', '#A88F86FF'],
        units: 'C',
    },
    showLegend: true,
    levels: {
        min: -10,
        interval: 10,
        max: 40,
    },
};

const mapboxStyleId = () => {
    if (window.location.host.startsWith('test-insights.metservice.com')) return 'clwqulq5x013201po1kbh7052';
    if (window.location.host.startsWith('uat-insights.metservice.com')) return 'clwohsgbb00rn01pp7qrv52m3';
    if (window.location.host.startsWith('insights.metservice.com')) return 'cl1pdcv34000014movqk9egrr';
    return 'clwqulq5x013201po1kbh7052';
};
export const defaultPlatMapSettings: PlatMapSettings = {
    accessToken: 'pk.eyJ1IjoibWV0b2NlYW4iLCJhIjoiY2phbHc2bnVzMnpqeTJ6cGxsMWhlNmN3ciJ9.SCk0GDY7t-S0z9zkUcMyfw',
    timeControl: {
        type: 'timespan',
        timespan: 'PT-3H--PT0S',
        markStep: 'PT10M',
        timeBetweenMarks: 1000,
        autoplay: true,
        showTimelineControls: true,
    },
    center: [150, -25] as [number, number],
    zoom: 2,
    timezone: 'Pacific/Auckland',
    topLabel: '',

    wxtiles: {
        serviceEndpoint: 'https://dev-platforms-data.cdn.metraweather.com/wxtiles',
        legendSize: 200,
    },
    _timeUnit: 'hours',
    layers: [
        {
            id: 'default1',
            state: {
                type: 'mapbox' as const,
                mapboxStyleId: mapboxStyleId(),
                disabledLayers: [],
            },
        },
    ],
    popups: [],
    showTimeOffsetSelector: false,
    isInteractive: false,
};
